import React, { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Send, Loader2 } from "lucide-react";
import { PROGRAMS } from "./siteData";
import { Reveal } from "./Reveal";

const API = process.env.REACT_APP_BACKEND_URL;

export const EnquiryForm = () => {
  const [form, setForm] = useState({ name: "", phone: "", email: "", program: "", message: "" });
  const [loading, setLoading] = useState(false);

  const update = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    if (!form.name.trim() || !form.phone.trim()) {
      toast.error("Please enter your name and phone number.");
      return;
    }
    setLoading(true);
    try {
      const res = await axios.post(`${API}/api/public/enquiry`, form);
      toast.success(res.data?.message || "Thank you! We will contact you soon.");
      setForm({ name: "", phone: "", email: "", program: "", message: "" });
    } catch (err) {
      toast.error("Something went wrong. Please call us instead.");
    } finally {
      setLoading(false);
    }
  };

  const inputCls =
    "w-full bg-zinc-950 border border-white/15 rounded-md px-4 py-3 text-white placeholder-zinc-500 focus:outline-none focus:border-gold focus:ring-1 focus:ring-gold font-body";

  return (
    <section id="contact" data-testid="enquiry-form-section" className="bg-black py-20 md:py-32">
      <div className="max-w-2xl mx-auto px-4 sm:px-6 lg:px-8">
        <Reveal>
          <div className="text-center mb-10">
            <span className="text-gold font-semibold uppercase tracking-[0.25em] text-sm">
              Get Started
            </span>
            <h2 className="font-bebas text-5xl sm:text-6xl text-white mt-3 leading-none">
              Start Your Fitness Journey
            </h2>
            <p className="text-zinc-400 mt-4 font-body">
              Fill this and our team will call you to book your free trial.
            </p>
          </div>

          <form
            onSubmit={submit}
            className="bg-zinc-900 border border-gold/20 rounded-2xl p-6 sm:p-8 space-y-4"
          >
            <div className="grid sm:grid-cols-2 gap-4">
              <input
                data-testid="enquiry-name"
                className={inputCls}
                placeholder="Your Name *"
                value={form.name}
                onChange={update("name")}
              />
              <input
                data-testid="enquiry-phone"
                className={inputCls}
                placeholder="Phone Number *"
                value={form.phone}
                onChange={update("phone")}
              />
            </div>
            <input
              data-testid="enquiry-email"
              type="email"
              className={inputCls}
              placeholder="Email (optional)"
              value={form.email}
              onChange={update("email")}
            />
            <select
              data-testid="enquiry-program"
              className={inputCls}
              value={form.program}
              onChange={update("program")}
            >
              <option value="">Interested in... (choose a program)</option>
              {PROGRAMS.map((p) => (
                <option key={p.name} value={p.name}>
                  {p.name}
                </option>
              ))}
              <option value="Membership">Membership Plan</option>
            </select>
            <textarea
              data-testid="enquiry-message"
              className={`${inputCls} resize-none`}
              rows={3}
              placeholder="Message (optional)"
              value={form.message}
              onChange={update("message")}
            />
            <button
              type="submit"
              disabled={loading}
              data-testid="enquiry-submit-button"
              className="w-full bg-gold hover:bg-gold_dark text-black font-bold uppercase tracking-wider px-6 py-4 rounded-md transition-all hover:scale-[1.01] flex items-center justify-center gap-2 disabled:opacity-60"
            >
              {loading ? <Loader2 size={18} className="animate-spin" /> : <Send size={18} />}
              {loading ? "Sending..." : "Book My Free Trial"}
            </button>
          </form>
        </Reveal>
      </div>
    </section>
  );
};
